module.exports = __webpack_public_path__ + "img/uart2.a32c0bed.png";